import { IInternetStatusListener } from "@home-health-notify/domain";

export const internetStatusListener: IInternetStatusListener = (
  setOffline: () => void,
  setPossiblyOnline: () => void,
) => {
  const handleOnline = () => setPossiblyOnline();
  const handleOffline = () => setOffline();

  window.addEventListener("online", handleOnline);
  window.addEventListener("offline", handleOffline);

  // Initial status check
  if (navigator.onLine) {
    setPossiblyOnline();
  } else {
    setOffline();
  }

  return () => {
    window.removeEventListener("online", handleOnline);
    window.removeEventListener("offline", handleOffline);
  };
};
